import React from 'react';
export function ProblemSection() {
  return <section className="bg-brand-dark pt-4 pb-0 px-5" data-id="element-245">
      <div className="max-w-xl mx-auto" data-id="element-246">
        <div className="bg-red-500/5 border border-red-500/10 rounded-3xl p-8 md:p-10" data-id="element-247">
          <h2 className="text-2xl md:text-3xl font-black text-white mb-6 leading-tight" data-id="element-248">
            El problema no es la crisis... <br data-id="element-249" />
            <span className="text-red-500" data-id="element-250">es no tener un sistema.</span>
          </h2>
          <p className="text-center text-brand-yellow font-bold text-lg mb-3" data-id="element-251">
            Te va a sonar familiar:
          </p>

          <div className="space-y-3 mb-10" data-id="element-252">
            {['Dependés completamente de supermercados, internet o electricidad', 'No sabés qué hacer ante un apagón o emergencia doméstica', 'Sentís que tu hogar no está preparado para situaciones reales', 'Te preocupa no tener agua, alimentos o herramientas básicas', 'Ves noticias sobre crisis, inflación o caos… y sentís incertidumbre'].map((problem, idx) => <div key={idx} className="bg-white/5 backdrop-blur-sm border border-white/10 p-4 rounded-xl flex items-start gap-3 transition-all hover:bg-white/10" data-id="element-253">
                <span className="text-red-500 text-lg flex-shrink-0" data-id="element-254">❌</span>
                <p className="text-sm text-gray-300 font-medium leading-relaxed" data-id="element-255">
                  {problem}
                </p>
              </div>)}
          </div>

          <div className="text-center" data-id="element-256">
            <h3 className="text-xl md:text-2xl font-bold text-brand-yellow mb-6" data-id="element-257">
              ¿Cuánto tiempo más vas a seguir esperando "a que nunca pase nada"?
            </h3>
          </div>

          <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-6 rounded-2xl mt-8 max-w-md mx-auto" data-id="element-258">
            <p className="text-white font-bold text-lg mb-4 text-center" data-id="element-259">
              Esto es lo que cambia cuando usás este sistema:
            </p>
            <div className="space-y-3" data-id="element-260">
              {['Tu hogar gana organización y preparación real', 'Reducís dependencia y ganás autonomía', 'Sabés qué hacer ante situaciones inesperadas', 'Protegés mejor a tu familia y recursos', 'Vivís con más tranquilidad y menos ansiedad'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-261">
                  <span className="text-green-500 font-bold text-lg" data-id="element-262">✔</span>
                  <p className="text-gray-300 text-sm font-medium" data-id="element-263">{item}</p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}